import releaseManifest from '../../../../release.json';

// Embedded in the installed bundle. The newly deployed API embeds the same
// root manifest, so an old PWA compares its old value with the API's new value.
export const CURRENT_APP_VERSION = releaseManifest.version;

const parseVersion = (version: string): number[] | null => {
  const match = /^v?(\d+)(?:\.(\d+))?(?:\.(\d+))?(?:\.(\d+))?$/.exec(version.trim());
  if (!match) return null;
  return match.slice(1).map((part) => Number(part ?? 0));
};

/**
 * Only a genuinely newer server release should light the update badge. A raw
 * inequality produces a false update during API/web rollbacks or staggered
 * deploys, and that looks exactly like a notification that cannot be cleared.
 */
export const isReleaseNewer = (candidate: string, current = CURRENT_APP_VERSION): boolean => {
  const next = parseVersion(candidate);
  const installed = parseVersion(current);
  if (!next || !installed) return false;

  for (let index = 0; index < Math.max(next.length, installed.length); index += 1) {
    const difference = (next[index] ?? 0) - (installed[index] ?? 0);
    if (difference !== 0) return difference > 0;
  }
  return false;
};
